import { ShapeProps, Slide } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import { texts, TextsOptions } from '../campaign-overview/texts';
import { buildCampaignOverviewSlide } from '@features/executive-report/slides/campaign-overview';
import { theme } from '@features/executive-report/domain/theme';

const DIMENSION_TEXT_OFFSET = 2.4;

export type CampaignOverviewSlideOptions = TextsOptions & {
  brandLogoWithMetadata: ImageWithMetadata | null;
};

const buildDimensionShapes = (index: number): ShapeProps[] => [
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: theme.colors.darkGray,
      },
      line: {
        color: theme.colors.inmarketGreen,
        width: 1,
      },
      h: 3.34,
      w: 2.2,
      x: 3.67 + index * DIMENSION_TEXT_OFFSET,
      y: 2.05,
    },
  },
  {
    shapeName: 'line',
    options: {
      line: {
        color: theme.colors.white,
        width: 1,
      },
      h: 0,
      w: 1.85,
      x: 3.85 + index * DIMENSION_TEXT_OFFSET,
      y: 3.26,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: theme.colors.inmarketGreen,
        transparency: 86,
      },
      h: 1.34,
      w: 1.85,
      x: 3.85 + index * DIMENSION_TEXT_OFFSET,
      y: 3.69,
    },
  },
];

export const campaignOverviewSlide = (
  options: CampaignOverviewSlideOptions
): Slide => {
  const dimensionShapes: ShapeProps[] = options.dimensionCounts.flatMap(
    (_, index) => buildDimensionShapes(index)
  );

  return buildCampaignOverviewSlide(
    texts(options),
    dimensionShapes,
    options.brandLogoWithMetadata,
    { x: 0.24, y: 2.05 }
  );
};
